export default __webpack_public_path__ + "static/media/file-icon.1ddfd53d.svg";